module.exports = __webpack_public_path__ + "static/media/detail_demo.ca9f40e7.png";